import {
  ACTION_GET_CARBON_EMISSION_ORG_PRODUCT,
  ACTION_GET_CARBON_EMISSION_ORG_PRODUCT_SUCCESS,
  ACTION_GET_CARBON_EMISSION_ORG_PRODUCT_FAILURE,
  API_CALL,
} from '../../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../../Status';

export function getCarbonEmissionOrgProduct(organizationId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/carbonOffsetProduct`,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }

          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_CARBON_EMISSION_ORG_PRODUCT,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_CARBON_EMISSION_ORG_PRODUCT_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_CARBON_EMISSION_ORG_PRODUCT_FAILURE,
    payload: responseJSON,
  };
}
